import { useState, useEffect } from 'react';
import VehiclesDataTiles from '../components/VehiclesDataTiles';
import VehiclesDataTable from '../components/VehiclesDataTable';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { List, Map } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};
export default function Addresses() {
  const navigate = useNavigate();
  const [tileData, setTilesData] = useState<ColumnObjType>();
  const handleTiles = (data: ColumnObjType) => {
    setTilesData(data);
  };
  const [view, setView] = useState('map');
  const location = useLocation();

  // Initialize filterData from URL on first render so children receive the
  // groupName immediately (prevents a first API call without the group, then
  // a second call after the effect sets the state).
  const initialFilterData = (() => {
    try {
      const params = new URLSearchParams(location.search);
      const groupName = params.get('depotName');
      const status = params.get('status');
      if (groupName) {
        const data: any = { group: groupName, vehicleGroup: groupName };
        if (status) data.vehicleStatus = status;
        return { data, isfiltered: true };
      }
      if (status) {
        return { data: { vehicleStatus: status }, isfiltered: true };
      }
    } catch (e) {
      // ignore
    }
    return { data: {}, isfiltered: false };
  })();

  const [filterData, setFilterData] = useState<{ data: any; isfiltered: boolean }>(initialFilterData);

  const handleChange = (_event: React.MouseEvent<HTMLElement>, newView: string | null) => {
    if (newView !== null) {
      setView(newView);
    }
  };
  return (
    <div className="flex flex-col gap-4">
      <div className="flex-1">
        <VehiclesDataTiles data={tileData} filterData={filterData} />
      </div>
      <div className="flex justify-center items-center">
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={handleChange}
          className="bg-[#EEEDFC] rounded-xl p-1 shadow-md"
        >
          <ToggleButton
            value="list"
            className={`px-4 py-1 flex items-center gap-2 text-sm rounded-lg shadow-none ${
              view === 'list' ? 'bg-white text-blue-600 font-semibold' : 'bg-transparent text-gray-700'
            }`}
            sx={{
              borderRadius: '18px',
              border: 'none',
            }}
          >
            <List className="w-5 h-5" />
            List View
          </ToggleButton>
          <ToggleButton
            value="map"
            className={`px-4 py-1 flex items-center gap-2 text-sm rounded-lg shadow-none ${
              view === 'map' ? 'bg-white text-blue-600 font-semibold' : 'bg-transparent text-gray-700'
            }`}
            sx={{
              borderRadius: '18px',
              border: 'none',
            }}
          >
            <Map className="w-5 h-5" />
            Map View
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      <div className="flex-1 tripTable">
        <VehiclesDataTable
          mapView={view === 'map'}
          handleTile={handleTiles}
          filterData={filterData}
          setFilterData={setFilterData}
        />
      </div>
    </div>
  );
}
